import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "refresh"

  connect() {
    super.connect()
    
    console.log('Refresh bridge component connected')
    console.log('bridgeSupported:', this.bridgeSupported)
    console.log('send method available:', typeof this.send)
    
    // Use setTimeout to ensure the bridge is fully initialized
    setTimeout(() => {
      console.log('Delayed check - bridgeSupported:', this.bridgeSupported)
      
      // Check if we're running in a native iOS app
      if (this.bridgeSupported) {
        console.log('Bridge supported, sending connect message')
        // Send initial connect message with refresh button title
        const title = this.data.get("title") || "Refresh"
        this.send("connect", { title })
      } else {
        console.log('Bridge not supported, refresh button will not be available')
      }
    }, 100)
  }

  // This method will be called by the iOS app when the refresh button is tapped
  // It receives the event name and any data sent from the iOS component
  receive(message) {
    console.log("Refresh message received from iOS:", message)
    
    if (message.data && message.data.refreshed) {
      console.log("Refresh requested from iOS, refreshing page...")
      
      // Trigger a page reload using Turbo
      if (window.Turbo) {
        window.Turbo.visit(window.location.href, { action: "replace" })
      } else {
        // Fallback to regular page reload
        window.location.reload()
      }
    }
  }
}
